import { useEffect } from "react";
import { AppStoreDownloadUrl } from "../assets";

const AppStoreRedirect = () => {
  useEffect(() => {
    window.location.replace(AppStoreDownloadUrl);
  }, []);

  return <div>Redirecting to the App Store...</div>;
};

export { AppStoreRedirect };